<template>
  <div class="wrapper">
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="clickItem"
    >
      {{ params.data.title }}
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    clickItem: function () {
      this.params.context.componentParent.clickItem(this.params.data);
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: 68px;
  display: flex;
  align-items: center;
}
</style>
